import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'

import initialState from './initialState'
import combinedReducers from './reducers'

const customizedMiddleware = getDefaultMiddleware({
  immutableCheck: false,
})

export const store = configureStore({
  reducer: combinedReducers,
  preloadedState: initialState(),
  middleware: customizedMiddleware
})
